module.exports = __webpack_public_path__ + "static/media/ham_gas_haz_lev.2a5778ec.png";